module.exports = require('./helpers/bundle-url').getBundleURL('gK5mg') + "accepted.17d3d1fb.png";